var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_112",
    "data-name": "Group 112",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.839,
    height: 23.148,
    viewBox: "0 0 18.839 23.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M109.064,85.567v15.371H106.7a2.7,2.7,0,0,0,0,5.4h1.688a2.7,2.7,0,0,0,2.7-2.7V92l9.724-1.676v8.589H118.45a2.7,2.7,0,0,0,0,5.4h1.688a2.7,2.7,0,0,0,2.7-2.7V83.192Z",
    transform: "translate(-104 -83.192)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.3ba2d4d1a90889206000f0dc735acd04.svg";
export { ForwardRef as ReactComponent };